import React, { useState } from 'react';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { AppActionTypes, QuipUser, RootState } from '../../redux/types';

import UserFormGroup from './UserFormGroup';
import ContentBox from '../layout/ContentBox';
import UserEditDialog from './UserEditDialog';

type Props = {
  user: QuipUser;
  onChange: () => Promise<void>;
  showNotification: (param: string | React.ReactElement) => AppActionTypes;
}

const UserDetails: React.FC<Props> = ({
  user,
  onChange,
  showNotification,
}: Props) => {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const locale = useSelector((state: RootState) => state.intl.locale);

  return (
    <ContentBox elevation={0} title={<FormattedMessage id="userDetails.userDataHeading" />}>
      <UserFormGroup
        userDetails={user}
        disabled
        locale={locale}
      />
      <Button
        variant="contained"
        onClick={() => {
          setEditDialogOpen(true);
        }}
        color="primary"
      >
        <FormattedMessage id="userDetails.editUser" />
      </Button>
      <UserEditDialog
        isOpen={editDialogOpen}
        userData={user}
        showNotification={showNotification}
        onClose={(requireRefresh?) => {
          setEditDialogOpen(false);
          if (requireRefresh) {
            onChange();
          }
        }}
        locale={locale}
      />
    </ContentBox>
  );
};

export default UserDetails;
